const index = {
    namespaced:true,   //开启命名空间，建议开启
    state:{
        imgUrl: process.env.VUE_APP_API_BASE_URL,
        addCartNum:0
    }
}

export default index